export default "__VITE_ASSET__CZeABk75__"